import { render, staticRenderFns } from "./PaginationTopShow.vue?vue&type=template&id=6841e362&lang=pug&"
import script from "./PaginationTopShow.vue?vue&type=script&lang=js&"
export * from "./PaginationTopShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports